module.exports = __webpack_public_path__ + "static/media/car-pin.ab04ebf1.svg";